module.exports = __webpack_public_path__ + "static/media/Tere.cf4e41fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/testimonials/Tere.png
// module id = 1420
// module chunks = 0